exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".current-file-view {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n  z-index: 100;\n}\n\n.current-file-view>.content {\n  position: relative;\n  overflow: scroll;\n}\n\n.current-file-view>.content img {\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n  border: 2px solid #0d3a52;\n}\n\n", ""]);

// exports
